/**
 * Cherobackground Component
 * Background layer with SVG mask for hero section
 */

'use client';

import type { CSSProperties, ReactElement } from 'react';
import { memo } from 'react';
import { CherobackgroundRoot } from './CherobackgroundRoot';
import { useCherobackgroundController } from './useCherobackgroundController';

export interface CherobackgroundProps {
  className?: string;
  style?: CSSProperties;
  delay?: number;
  entranceReady?: boolean;
  onAnimationEvent?: (eventName: string) => void;
}

export const Cherobackground = memo(function Cherobackground({
  className,
  style,
  delay = 0,
  entranceReady = true,
  onAnimationEvent,
}: CherobackgroundProps): ReactElement {
  const controller = useCherobackgroundController({ delay, entranceReady, onAnimationEvent });

  return (
    <CherobackgroundRoot
      backgroundMode={controller.backgroundMode}
      className={className}
      glow={controller.glow}
      handlePrismError={controller.handlePrismError}
      handlePrismFpsSample={controller.handlePrismFpsSample}
      isMobile={controller.isMobile}
      prismConfig={controller.prismConfig}
      scale={controller.scale}
      style={style}
    />
  );
});
